// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as Theme__Typography$PrezzeeRibbon from "../../../theme/Theme__Typography.bs.js";

var menuBlock = BsCssJs$PrezzeeRibbon.merge([
      Theme__Typography$PrezzeeRibbon.Styles.body,
      BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.charcoal)])
    ]);

var Styles = {
  menuBlock: menuBlock
};

function ProfileMenu(props) {
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: menuBlock
            });
}

var Line;

var Section;

var HiLine;

var make = ProfileMenu;

export {
  Styles ,
  Line ,
  Section ,
  HiLine ,
  make ,
}
/* menuBlock Not a pure module */
